module.exports = __webpack_public_path__ + "img/spint-blue.6212ebdb.png";